export const googleCountriesToSFDCCountries = {
    'American Samoa': 'United States',
    'US Virgin Islands': 'United States',
    'U.S. Virgin Islands': 'United States',
}


export const countriesToStates = {
    'united states': ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "US Virgin Islands", "American Samoa", "Puerto Rico"],
    'canada': ['Ontario', 'Quebec', 'British Columbia', 'Alberta', 'Manitoba', 'Saskatchewan', 'Nova Scotia', 'New Brunswick', 'Newfoundland and Labrador', 'Prince Edward Island', 'Northwest Territories', 'Nunavut', 'Yukon Territories'],
    'ireland': ['Carlow', 'Cavan', 'Clare', 'Cork', 'Donegal', 'Dublin', 'Galway', 'Kerry', 'Kildare', 'Kilkenny', 'Laois', 'Leitrim', 'Limerick', 'Longford', 'Louth', 'Mayo', 'Meath', 'Monaghan', 'Offaly', 'Roscommon', 'Sligo', 'Tipperary', 'Waterford', 'Westmeath', 'Wexford', 'Wicklow']
}


export const validCountries = [
    'united states', 'canada', 'mexico', 'united kingdom',
    'ireland', 'france', 'germany', 'netherlands', 'belgium',
    'austria', 'switzerland', 'spain', 'italy', 'luxembourg',
    'liechtenstein'
];

export const countriesWithoutStates = [
    'united kingdom', 'france', 'belgium', 'germany',
    'luxembourg', 'liechtenstein', 'austria', 'netherlands',
    'switzerland', 'spain', 'italy', 'mexico'
];


// Google api returns all irish states prefix by 'County '. Map those state values to SFDC state values
export const irishGoogleStateNamesToSFDC = countriesToStates.ireland.reduce((mapping, sfdcState) => {mapping[`County ${sfdcState}`] = sfdcState; return mapping;}, {});


export const googleStateNamesToSFDC = {
    'Yukon': 'Yukon Territories',
    'U.S. Virgin Islands': 'US Virgin Islands',
    ...irishGoogleStateNamesToSFDC
}
